import React, { Fragment, useContext } from "react";

import clsx from "clsx";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Avatar,
  IconButton,
  Box,
  Typography,
  Menu,
  Button,
  List,
  ListItem,
} from "@material-ui/core";

import avatar2 from "../../assets/images/avatars/avatar2.jpg";
import { connect } from "react-redux";
import userContext from "contexts/userContext";

import MoreVertIcon from "@material-ui/icons/MoreVert";

const SidebarUserbox = (props) => {
  const { role, setRole } = useContext(userContext);
  const history = useHistory();
  const { sidebarToggle, sidebarHover } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  function openUserMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }
  const gotoProfile = () => {
    history.push("/Profile");
  };

  return (
    <Fragment>
      <Box
        className={clsx("app-sidebar-userbox", {
          "app-sidebar-userbox--collapsed": sidebarToggle && !sidebarHover,
        })}
      >
        <Avatar
          alt="Remy Sharp"
          src={role.user ? role.user.profile_photo_path : ""}
          className="app-sidebar-userbox-avatar"
        />
        <Box className="app-sidebar-userbox-name">
          <div className="pl-2">
            <span className="pb-1 d-block">{role.user && role.user.name}</span>
            {/* <div className="divider my-2"></div> */}
            <div className="pb-1 d-block text-info">
              {role.user &&
                role.user.company &&
                role.user.company.raison_sociale}
            </div>
            {role.user && role.user.poste}
          </div>
        </Box>
        <Box className="app-sidebar-userbox-btn-profile">
          <Button
            size="small"
            color="secondary"
            variant="contained"
            className="text-white"
            onClick={() => {
              gotoProfile();
            }}
          >
            Voir le profil
          </Button>
        </Box>
      </Box>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarHover: state.ThemeOptions.sidebarHover,
});

export default connect(mapStateToProps)(SidebarUserbox);
